import { countries as Countries } from 'countries-list';
import { orderBy } from 'lodash';

const { US, ...restCountries } = Countries;

const GivebutterCountries = {
    ...restCountries,
    USA: US,
};

const ORDERED_COUNTRIES = orderBy(
    Object.keys(GivebutterCountries).map(key => ({
        abbr: key,
        ...GivebutterCountries[key as keyof typeof GivebutterCountries],
    })),
    ['name'],
    ['asc'],
);

const ORDERED_COUNTRIES_WITHOUT_USA = ORDERED_COUNTRIES.filter(country => country?.abbr !== 'USA');

export { GivebutterCountries, ORDERED_COUNTRIES, ORDERED_COUNTRIES_WITHOUT_USA };
